export default __webpack_public_path__ + "static/media/Manual-3.eda469f4.png";